export const SEE_DETAILED = "SEE_DETAILED"